import React, { useEffect, useMemo } from 'react';
import Footer from '../components/Sections/Footer';
import '../components/CardProduct/cardProduct.css';
import CardProduct from '../components/CardProduct/cardProduct'
import { useDispatch, useSelector } from 'react-redux';
import { GetproductWomen, numberWithCommas } from '../redux/actions/product';
import Navigations from '../components/Nav/navigations';
import { Link } from 'react-router-dom';
import { checkPhoto } from '../components/CardProduct/cardProduct.function';


export default function ProductWomen() {
  const dispatch = useDispatch();

  const { dataWomen, dataSearch } = useSelector((s) => s.Product);

  useEffect(() => {
    dispatch(GetproductWomen())
  }, [dispatch, dataSearch?.payload])

  const filterSearch = useMemo(() => {
    console.log(dataSearch.payload)
    return dataWomen?.filter((val) => val.product_label === dataSearch.payload)
  },[dataSearch?.payload, dataWomen])

  return (
    <div className="page-wrapper">
      <Navigations />
      <div className="container content-wrapper">
        <div className='mt100'>
          <h3 className="font40 extraBold textCenter fontRobotto">{`Fashion Women (${dataSearch.payload})`}</h3>
          {filterSearch?.length > 0 ? (
            <div className="subcontainer">
            <div className="grid">
              {filterSearch?.map((item, index) => (
                <Link to={`/detail_product/product/${item?.product_id}`}>
                <CardProduct
                  key={index}
                  image={checkPhoto(item.product_photo, 'product')}
                  title={item.product_name}
                  price={numberWithCommas(item.product_price)}
                />
                </Link>
              ))}
            </div>
          </div>
          ) : (
            <p className='fontEmptyData font20 fontCabin'>Sorry, there are no products in this collection</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  )
}
